import { priceAlertMessage,priceAlertName } from './content.js'
import { readAlertPresentation } from './presentation.js'
import { supabase } from '../supabase.js'

async function authorizedFetch(owner, options) {
  const {data:{session}}=await supabase.auth.getSession()
  if (!session || session.user?.id !== owner) throw new Error('Sign in to use alerts')
  return fetch('/api/price-alerts'+(options.after == null ? '' : `?after=${options.after}`),{
    method:options.method || 'GET',signal:options.signal,
    headers:{Authorization:`Bearer ${session.access_token}`,'Content-Type':'application/json',Accept:options.body?'application/json':'text/event-stream'},
    body:options.body ? JSON.stringify(options.body) : undefined,
  })
}
export async function alertCommand(owner,body,signal) {
  const response=await authorizedFetch(owner,{method:'POST',body,signal})
  const result=await response.json()
  if (!response.ok) throw new Error(result.error || 'Alert could not be saved')
  return result
}
export async function consumeAlertStream(response,onFrame,signal) {
  if (!response.ok || !response.headers.get('content-type')?.includes('text/event-stream') || !response.body) throw new Error('Alert stream unavailable')
  const reader=response.body.getReader(),decoder=new TextDecoder()
  let buffer='',received=false
  try {
    while (!signal?.aborted) {
      const {value,done}=await reader.read()
      if (done) break
      buffer+=decoder.decode(value,{stream:true})
      if (buffer.length>2_000_000) throw new Error('Alert stream exceeded frame limit')
      // Normalize only complete frames, including CRLF split between chunks.
      const separator=/\r?\n\r?\n/
      let match
      while ((match=separator.exec(buffer))) {
        const frame=buffer.slice(0,match.index).replace(/\r\n/g,'\n');buffer=buffer.slice(match.index+match[0].length)
        const lines=frame.split('\n'),kind=lines.find(l=>l.startsWith('event:'))?.slice(6).trim()
        if (!['snapshot','alert'].includes(kind)) continue
        const data=JSON.parse(lines.filter(l=>l.startsWith('data:')).map(l=>l.slice(5).trimStart()).join('\n'))
        if (kind==='snapshot' && (data.schemaVersion!==1 || !Array.isArray(data.alerts) || !Array.isArray(data.receipts) || !Number.isSafeInteger(data.cursor))) throw new Error('Invalid alert snapshot')
        if (kind==='alert' && (!Number.isSafeInteger(data.seq) || !['changed','deleted','triggered'].includes(data.kind) || !data.payload)) throw new Error('Invalid alert event')
        if (signal?.aborted) return
        received=true;onFrame(kind,data)
      }
    }
    if (!received) throw new Error('Alert stream empty')
  } finally { await reader.cancel().catch(()=>{});reader.releaseLock() }
}
export async function streamAlerts(owner,{after,onFrame,signal}) {
  return consumeAlertStream(await authorizedFetch(owner,{after,signal}),onFrame,signal)
}

export function alertNotification(event,owner,now=Date.now()) {
  const when=new Date(event.createdAt*1000).toISOString()
  const id=`price-alert:${owner}:${event.id}`
  // serverBacked is reserved by NotificationsProvider for broker-table writes.
  return {id,source:'price-alert',serverBacked:false,ownerUserId:owner,
    type:'price_alert',alertId:event.alertId,alertRevision:event.revision,title:priceAlertName(event.symbol,event.name),symbol:event.symbol,tone:'info',createdAt:when,firedAt:when,
    message:priceAlertMessage(priceAlertName(event.symbol,event.name),event.message,`${event.symbol} ${Number(event.price).toFixed(2)} crossed ${Number(event.threshold).toFixed(2)}${event.timing==='bar_close'?' at candle close':''}.`),
    popupDismissed:now-event.createdAt*1000>60000,
    details:[{label:'Alert rule',value:event.condition},{label:'Trigger price',value:String(event.price)},{label:'Threshold',value:String(event.threshold)},{label:'Session',value:event.session},{label:'Rule revision',value:String(event.revision)}],
    workspaceRoute:`/positions/workspace?symbol=${encodeURIComponent(event.symbol)}`, ...readAlertPresentation(owner,id)}
}
